import {useEffect} from 'react'
import {KSideBarMenuApps} from '../../../../../app/khipu/components/Layout/KSideBarMenuApps'
import {SidebarMenuCentral} from '../../../../../app/khipu/features/central/components/Layout'
import {SidebarMenuHoteleria} from '../../../../../app/khipu/features/hoteleria/components/Layout'
import {SidebarMenuLavanderia} from '../../../../../app/khipu/features/lavanderia/components/Layout'
import {SidebarMenuLimpieza} from '../../../../../app/khipu/features/limpieza/components/Layout'
import {useKhipu} from '../../../../../app/khipu/hooks/useKhipu'
import {ScrollComponent} from '../../../../assets/ts/components'

const SidebarMenu = () => {
  const {applicationId} = useKhipu()

  const APPS = {
    Panel: <></>,
    Central: <SidebarMenuCentral />,
    Hotelería: <SidebarMenuHoteleria />,
    Lavandería: <SidebarMenuLavanderia />,
    Hospitality: <SidebarMenuLimpieza />,
  } as any

  // Reinicializar el scroll cuando cambie el applicationId o el contenido del menú
  useEffect(() => {
    const reinitScroll = () => {
      const sidebarWrapper = document.getElementById('kt_app_sidebar_menu_wrapper')
      if (sidebarWrapper) {
        // Reinicializar el scroll del sidebar
        ScrollComponent.reinitialization('[data-kt-scroll="true"]')
        // Actualizar todas las instancias de scroll
        ScrollComponent.updateAll()
      }
    }

    // Reinicializar después de un pequeño delay para asegurar que el DOM se haya actualizado
    const timer = setTimeout(() => {
      reinitScroll()
    }, 100)

    // Observar cambios en el contenido del menú para reinicializar el scroll
    const menuElement = document.getElementById('kt_app_sidebar_menu')
    if (menuElement) {
      const observer = new MutationObserver(() => {
        // Reinicializar el scroll cuando cambie el contenido del menú
        setTimeout(() => {
          reinitScroll()
        }, 50)
      })

      observer.observe(menuElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style'],
      })

      return () => {
        clearTimeout(timer)
        observer.disconnect()
      }
    }

    return () => clearTimeout(timer)
  }, [applicationId])

  return (
    <div className='app-sidebar-menu overflow-hidden flex-column-fluid'>
      <div
        id='kt_app_sidebar_menu_wrapper'
        className='app-sidebar-wrapper hover-scroll-overlay-y my-5'
        data-kt-scroll='true'
        data-kt-scroll-activate='true'
        data-kt-scroll-height='auto'
        data-kt-scroll-dependencies='#kt_app_sidebar_logo, #kt_app_sidebar_footer'
        data-kt-scroll-wrappers='#kt_app_sidebar_menu'
        data-kt-scroll-offset='5px'
        data-kt-scroll-save-state='true'
      >
        <div
          className='menu menu-column menu-rounded menu-sub-indention px-3'
          id='kt_app_sidebar_menu'
          data-kt-menu='true'
          data-kt-menu-expand='false'
        >
          {APPS[applicationId]}
          <KSideBarMenuApps />
        </div>
      </div>
    </div>
  )
}

export {SidebarMenu}
